import React, { Fragment } from 'react';
import { Route } from 'react-router-dom';

import Report from './Pages/Report';

const worldRoutes = () => {
    return (
        <Fragment>
            <Route path="/report" exact component={Report} />
        </Fragment>
    )
};

export default worldRoutes;

